// 新聞文章內 替換 輪播
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import Image from 'next/image';
import '../../styles/swiper.scss';

const NewsSwiper = ({ slides }) => {
    let newSlides = slides;
    if (typeof slides === 'string') newSlides = JSON.parse(slides);

    if (slides && slides?.length > 0)
        return (
            <Swiper
                className="w-full aspect-[16/9] mt-[45px] cursor-grab !pb-[30px]"
                modules={[Autoplay, Pagination]}
                pagination={{ clickable: true }}
                centeredSlides={true} // 居中顯示當前 slide
                slidesPerView={1}
                loop={true}
                direction={'horizontal'} // 水平方向
                freeMode={true}
                autoplay={{
                    delay: 4000,
                }}
            >
                {newSlides?.map((img, i) => (
                    <SwiperSlide key={'swiper' + img?.image + i} className="w-full h-full">
                        <div className="img-box w-full h-full after:content-none rounded-[4px] overflow-hidden">
                            <Image
                                src={img?.url}
                                width={680}
                                height={358}
                                sizes="(max-width: 599px) 80vw, 650px"
                                alt={img?.desc || 'news_swiper'}
                                loading="lazy"
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        );

    return <></>;
};

export default NewsSwiper;
